import { CheckCircleOutlined, WarningOutlined } from "@/icons"

import styles from "./Flow.module.scss"

export const Icon = ({ isFalsePositive }: { isFalsePositive?: boolean }) => {
  if (isFalsePositive)
    return <CheckCircleOutlined className={styles.iconSuccess} />

  return <WarningOutlined className={styles.iconWarning} />
}
